// extracted by mini-css-extract-plugin
export default {"body":"contacto_body__flwzx","contact-section":"contacto_contact-section__FwzBO","social-media":"contacto_social-media__d2V5l","icon":"contacto_icon__EIY4U"};